export default "__VITE_ASSET__DEqRKJmV__"